import { createApi } from '@reduxjs/toolkit/query/react'

import {
  EstadoHorizontalReserva,
  EstadoHorizontalReservaResponse,
} from '../interfaces/EstadoHorizontalReservas'
import { EstadoVerticalReservas } from '../interfaces/EstadoVerticalReservas'

import { baseQuery } from '@/core/api/baseQuery'

export const estadosLogicosApi = createApi({
  reducerPath: 'estadoVerticalReservasApi',
  baseQuery,
  endpoints: (builder) => ({
    getEstadoVerticalReservas: builder.query<
      EstadoVerticalReservas[],
      number | undefined
    >({
      query: (id) => ({
        url: `ReservaCentralizadaBusiness/EstadosLogicosVerticales?menuReservaId=${id}`,
        method: 'GET',
      }),
    }),
    getEstadosHorizontalesReservas: builder.query<
      EstadoHorizontalReserva[],
      { id: number }
    >({
      query: ({ id }) => ({
        url: `ReservaCentralizadaBusiness/EstadosLogicosHorizontales?menuReservaId=${id}`,
        method: 'GET',
      }),
      transformResponse: (response: EstadoHorizontalReservaResponse[]) => {
        return response.map((item) => ({
          estadoLogicoReservaId: item.estadoLogicoReservaId,
          nombre: item.nombre,
          esEstadoHorizontal: item.esEstadoHorizontal,
          esEstadoVertical: item.esEstadoVertical,
        }))
      },
    }),
  }),
})

export const {
  useLazyGetEstadoVerticalReservasQuery,
  useLazyGetEstadosHorizontalesReservasQuery,
} = estadosLogicosApi
